import axios from 'axios';

// const { getAccountNumber } = require('./getAccountNumber.js');
const { handleOAuthFlow } = require('./oauth_flow');

const nexum_sym = process.env.REACT_APP_NEXUM_SYM;
//const nexum_prod_sym = process.env.REACT_APP_NEXUM_PROD_SYM;
const nexum_api_key = process.env.REACT_APP_NEXUM_API_KEY;
const nexum_dev_endpoint = process.env.REACT_APP_NEXUM_DEV_ENDPOINT;
const nexum_ac = process.env.REACT_APP_NEXUM_AC;
const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT;
const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;



const config = {
  headers: {
    'Authorization': `Bearer ${nexum_api_key}`,
    'Content-Type': 'application/json'
  }
};

// Utility function to get account number
const getMemberInfo = async () => {
  const timeout = 5000;

  // Check for existing authentication
  const existingAuth = localStorage.getItem('auth_data');
  if (existingAuth) {
    try {
      const authData = JSON.parse(existingAuth);
      // Check if the auth data is still valid (you might want to add expiration check here)
      return authData;
    } catch (e) {
      
      localStorage.removeItem('auth_data');
    }
  }

  // Get query parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  
  try {
    // Validate required parameters
    if (!plugin_client_id || !plugin_client_secret || !plugin_environment) {
        throw new Error('Missing required parameters');
    } 

    // Create a promise that rejects after timeout
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error(`Request timed out after ${timeout}ms`));
        }, timeout);
    });

    const req = {
      code: code,
      state: state
    }

    const requestPromise = handleOAuthFlow({
      plugin_environment,
      plugin_client_id,
      plugin_client_secret,
      plugin_redirecturi,
      req
    });

    // Race between the timeout and the actual request
    const result = await Promise.race([requestPromise, timeoutPromise]);
    
    if (result) {
      if (result.results === 'OK'){
        // Store the successful authentication data
        localStorage.setItem('auth_data', JSON.stringify(result));
        return result;
      } else if (result.results === 'ERROR'){
          throw new Error(result.error);
      } else {
          // Store state and code_verifier in localStorage
          localStorage.setItem(`STATE_${result.state}`, result.code_verifier);
          // Redirect to the authorization URL
          window.location.href = result.redirect_url;
          return null;        
      }
    }
  } catch(error) {
      return {
          results: "ERROR",
          error: error.message,
          member_number: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          user_type: "",
          user_name: "",
          phone_number: ""
      };
  }
};


export const fetchDashboardData = async () => {
  let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }

    
    const nexum_body = {
        "Credentials": {
          "AdministrativeCredentials": {
              "Password": nexum_ac
          }
        },
        "Header": {
            "MessageID": "1",
            "RGState": "THESTATE"
        },
        "Body": {
            "File": "MSJ.SYMX.MYOFFERS.PND",
            "RGSession": 1,
            "UserDefinedParameters": {
                "RGUserChr": [
                    {
                        "ID": "1",
                        "Value": member_info.member_number.padStart(10,"0")
                    }
                ]
            }
        }
      };
    
    

    const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
    const response = await axios.post(url, nexum_body, config);
    
    

    const raw = response?.data?.Body?.RGLines;

  
    if (!raw || raw.trim() === "" || raw.trim() === "null") {
      return null;
    }

    return JSON.parse(raw.trim());
  } catch (error) {
    
throw error;
  }
};

const getApplicationType = (applicationName) => {
    const mapping = {
        "Auto Loan": 1,
        "New Vehicle": 1,
        "Used Vehicle": 1,
        "Unsecured Loan Application": 2,
        "Platinum Visa Application": 3,
        "Smart Rewards Application": 4,
        "MAX Signature Application": 5
    };
    return mapping[applicationName] || 0;
};

export const CloseOffer = async (loanType) => {
    try {
        const member_info = await getMemberInfo();
        if (!member_info || member_info.results === 'ERROR') {
            throw new Error(member_info?.error || 'Failed to get member info');
        }

        const loanCode = getApplicationType(loanType);

        
        const nexum_body = {
            "Credentials": {
                "AdministrativeCredentials": {
                    "Password": nexum_ac
                }
            },
            "Header": {
                "MessageID": "1",
                "RGState": "CloseOffer"
            },
            "Body": {
                "File": "MSJ.SYMX.MYOFFERS.PND",
                "RGSession": 1,
                "UserDefinedParameters": {
                    "RGUserChr": [
                        {
                            "ID": "1",
                            "Value": member_info.member_number.padStart(10,"0")
                        },
                        {
                            "ID": "2",
                            "Value": loanCode.toString()
                        }
                    ]
                }
            }
        };
        
        const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
        const response = await axios.post(url, nexum_body, config);
        
        // Debug logging
  
        
        // Check if RGLines is already an object
        if (typeof response.data.Body.RGLines === 'object') {
            return response.data.Body.RGLines;
        }
        
        // Fix malformed JSON by wrapping it in curly braces if needed
        const rglines = response.data.Body.RGLines;
        if (rglines && typeof rglines === 'string') {
            try {
                // Try parsing as is first
                return JSON.parse(rglines);
            } catch (e) {
                // If that fails, try wrapping in curly braces
                try {
                    return JSON.parse(`{${rglines}}`);
                } catch (e2) {
                    // If both attempts fail, return a simple success object
                    return { MyOffer: [{ Offer: "Closed" }] };
                }
            }
        }
        
        // Default fallback
        return { MyOffer: [{ Offer: "Closed" }] };
    } catch (error) {
        
        // Return a success object even if there's an error
        return { MyOffer: [{ Offer: "Closed" }] };
    }
};

